
import { defineComponent, ref, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";

//components
import Header from "@/components/shared/Header.vue"
import subHeader from "@/components/shared/subHeader.vue"
import KTFile from "@/components/files/File.vue";
//import Footer from "@/layout/footer/Footer.vue"

//services
import servCertificate from "@/core/services/CertificateService"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name:"Certificates",
    components: {
        Header, subHeader, KTFile
    },
    setup() {
        
        const i18n = useI18n();
        const loading = ref(false)
        const urlDownload = ref(process.env.VUE_APP_API_URL)
        const listCourses = ref<any>([])
        const searchFormRef = ref<FormInstance>()
        const searchForm = reactive(<any> {
            periodo: 2024,
            category: null,
            doctype: '1',
            docnumber: null
        })

        const rules = reactive (<FormRules> {
            doctype: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            docnumber: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const submitForm = async (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            await formEl.validate((valid, fields) => {
                if(valid) onSearch();
            });
        }

        const onSearch = async () => {
            loading.value = true;
            listCourses.value = []
            servCertificate.getSearch(searchForm)
            .then( (res) => {
                loading.value = false;
                listCourses.value = res.data.courses
                if(res.data.status !='success')
                    Swal.fire({
                        icon: res.data.status,
                        title: res.data.title,
                        html: res.data.message
                    })
            }).catch( ({response}) => {
                loading.value = false;
                errManager(response)
            })
        }

        const setLang = (lang) => {
            localStorage.setItem("lang", lang);
            i18n.locale.value = lang;
        };

        onMounted(() => {
            setLang("es")
        });

        return {
            loading,
            listCourses,
            urlDownload,
            searchFormRef,
            searchForm,
            rules,

            //methods
            submitForm,
            onSearch,
            setLang
        }
    },
})
